import React from 'react';
import { Shield } from 'lucide-react';

export const BuckleArrestorSection = () => {
  return (
    <div className="border-l-2 border-purple-200 pl-4">
      <h5 className="text-purple-800 font-medium mb-4 flex items-center gap-2">
        <Shield className="h-5 w-5" />
        Buckle Arrestor
      </h5>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 relative">
        {/* Vertical Separators */}
        <div className="absolute inset-y-0 left-[20%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[40%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[60%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[80%] w-px bg-gray-200" />

        {/* Material Traceability */}
        <div className="space-y-2">
          <div className="px-3 py-2 bg-orange-100 text-orange-800 rounded-md inline-block">
            Material Traceability
          </div>
        </div>

        {/* PipeFitter */}
        <div className="space-y-2">
          <div className="px-3 py-2 bg-green-100 text-green-800 rounded-md inline-block">
            PipeFitter
          </div>
        </div>

        {/* Welding */}
        <div className="space-y-4">
          <div className="px-3 py-2 bg-purple-100 text-purple-800 rounded-md inline-block">
            Welding
          </div>
          <div className="space-y-3">
            <div>
              <p className="text-sm font-medium text-gray-700 mb-2">CRCE Machines</p>
              <div className="flex flex-wrap gap-2">
                <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-sm">IWM</div>
                <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-sm">P-625</div>
                <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-sm">P-600Z</div>
                <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-sm">M-500</div>
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-700 mb-2">Non CRCE Machines</p>
              <div className="flex flex-wrap gap-2">
                <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-sm">Manual</div>
                <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-sm">Competitor Machine</div>
              </div>
            </div>
          </div>
        </div>

        {/* NDT */}
        <div className="space-y-2">
          <div className="px-3 py-2 bg-yellow-100 text-yellow-800 rounded-md inline-block">
            NDT
          </div>
        </div>

        {/* Coating */}
        <div className="space-y-2">
          <div className="px-3 py-2 bg-indigo-100 text-indigo-800 rounded-md inline-block">
            Coating
          </div>
        </div>
      </div>
    </div>
  );
}; 